/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { Component, EventEmitter, Input, Output } from "@angular/core";
import { AddressPickerSharedState } from "../address-picker-shared-state";
import { CommonModule } from "@angular/common";
import { ButtonModule } from "primeng/button";
import { AddressDTO } from "@well/address-management-domain-model";

@Component({
  selector: 'well-address-as-string-view',
  templateUrl: './address-as-string-view.component.html',
  styleUrls: ['./address-as-string-view.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule],
})
export class AddressAsStringViewComponent {
  @Input() editString = true;
  @Input() localState: AddressPickerSharedState | undefined = undefined;
  @Output() showDetails: EventEmitter<boolean> = new EventEmitter<boolean>();

  @Input()
  set externalAddressFormGroup(addressForm: AddressDTO) {
    if (addressForm) {
      this._addressForm = addressForm;
    }
  }

  get addressForm(): AddressDTO {
    return this._addressForm;
  }

  private _addressForm: AddressDTO | undefined = undefined;

  editAddress() {
    this.showDetails.next(true);
  }
}
